import React from 'react';
import useTrackPageShown from 'src/viewLayer/components/hooks/useTrackPageShown';
import TrackableButton from 'src/viewLayer/components/shared/TrackableButton';
import HandCardImage from 'src/viewLayer/components/pages/Images/HandCard.svg';
import ScribbleImage from 'src/viewLayer/components/pages/Images/Scribble.svg';
import { useAppConfigContext } from 'src/viewLayer/components/contexts/AppConfigContext';
import { useBusinessPagePath, useEmailPagePath } from 'src/viewLayer/navigation';
import { namespaceT } from 'src/viewLayer/helpers/translations';
import './index.scss';

const BackgroundItems = [HandCardImage, ScribbleImage];

export default function BusinessErrorPage({ appType }) {
  useTrackPageShown({ appType,  pageType: 'b2b_sso_error' });

  const isNativeMobileView = useAppConfigContext().devicePath === 'login-mobile';
  const nativeMobilePagePath = useBusinessPagePath();
  const webPagePath = useEmailPagePath();
  const pagePath = isNativeMobileView ? nativeMobilePagePath : webPagePath;

  const t = namespaceT('email.error.invalid_company_email');

  return (
    <div className="BusinessErrorPage" data-testid="business-error-page">
      <div>
        <h1>{ t('title') }</h1>
        <div className="message">{ t('body') }</div>
        <div className="actions">
          <TrackableButton
            data-testid="gotit-button"
            variant="secondary"
            trackingId="sso_error_gotit"
            spaHREF={ pagePath }
            >
              { t('cta') }
          </TrackableButton>
        </div>
      </div>
      <div className="bg-items">
        {BackgroundItems && BackgroundItems.map((BackgroundItem, index) => (
            <BackgroundItem key={index} />
        ))}
      </div>
    </div>
  );
};
